<div style="text-align: center; height: 100%">
    <app-dwv></app-dwv> 
</div>
